import { gateway } from "../../../gateway";
import { TimeSheetParams, TimeSheetResponse } from "../interfaces/time-sheet.interfaces";

export const getTImeSheets = async (params?: TimeSheetParams): Promise<TimeSheetResponse> => {
    const { range, ...rest } = params ?? {};
    const data = await gateway.get<TimeSheetResponse>("/timesheets", {
        params: {
            ...rest,
            ...(range?.start && range?.end
                ? {
                      "range[start]": range.start,
                      "range[end]": range.end,
                  }
                : {}),
        },
    });
    return data.data;
}